export default function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ../~/dom-helpers/esm/ownerDocument.js
// module id = 394
// module chunks = 121